import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useGetErrorResponseMessage } from 'js/hooks/server';
import { useShowNotification } from 'js/components/common/Notifications';

import { confirmSingleBetLimit } from '../server';

export const useConfirmPlayerLimits = ({ action, setIsLoading, setConfirmError, fetchLimits }) => {
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const showNotification = useShowNotification({ iconType: 'info' });
    const t = useTranslations('playtech.mobile.system.responsibleGaming.limits.');

    return useCallback(async () => {
        setIsLoading(true);
        setConfirmError('');

        try {
            await confirmSingleBetLimit(action);

            showNotification({ message: t(`${action}Success`) });
            fetchLimits(Date.now());
        } catch (error) {
            const errorMessage = getErrorResponseMessage(error);

            setConfirmError(errorMessage);
            setIsLoading(false);
        }
    }, [
        action, setIsLoading, setConfirmError, fetchLimits,
        getErrorResponseMessage, t, showNotification
    ]);
};
